import { isDev, isLocalhost } from "./env";
import { getDomain } from "./domain";
import { Cookie } from "./index";

interface NavigateProps {
  isDomestic?: boolean;
  path?: string;
  searchParams?: string;
  target?: string;
}

export function navigateToUserCenter({
  isDomestic = getDomain() === 0,
  path = "profile",
  searchParams = "",
  target = "_self",
}: NavigateProps) {
  // 如果path为空，则默认打开profile
  const _path = path || "profile";
  const isAuthLogin = Cookie.getCookie("rayvision_isAuthLogin");
  if (isAuthLogin) return;
  // 本地开发时，直接打开本地用户中心
  if (isLocalhost()) {
    console.log(
      "Localhost",
      `http://127.0.0.1:3001/${_path}${searchParams ? `?${searchParams}` : ""}`
    );
    window.open(
      `http://127.0.0.1:3001/${_path}${searchParams ? `?${searchParams}` : ""}`,
      target
    );
  } else {
    window.open(
      `https://${isDev() ? "account-pre" : "account"}.${
        isDomestic ? "renderbus" : "foxrenderfarm"
      }.com/center/user/${_path}${searchParams ? `?${searchParams}` : ""}`,
      target
    );
  }
}
